var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subfunds-bankmanage"},[_c('TagsCloud',{ref:"cloudtage",on:{"cloudTages":_vm.cloudTages}}),_c('Index',{attrs:{"files":_vm.files},on:{"rowdata":_vm.rowdata}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }